/** Said at the top of a default's sheet: what a save reaches, and what it leaves alone */
export const unitDefaultHint =
  'Saving here changes nothing on the units already added; only units added from now on start with these.';
